import React from "react"
import { transformVar } from "@quarkly/atomize"
import { createGlobalStyle } from "styled-components"
import { RawHtml } from "@quarkly/components"

const pageStyles = {
  "404": {
    background: "",
  },
  index: {
    background: "",
  },
  "privacy-policy": {
    background: "",
  },
  "terms-and-conditions": {
    background: "",
  },
}

const PageStyles = createGlobalStyle`
    body {
        ${({ styles }) =>
          Object.entries(styles || {}).map(
            ([prop, value]) => `${prop}: ${transformVar(prop, value)};`
          )}
    }
`

const GlobalCSS = () => (
  <RawHtml>
    <style place={"endOfHead"} rawKey={"60da14fa3f4eb1001ea27687"}>
      {`:root {
  box-sizing: border-box;
}

* {
  box-sizing: inherit;
}

/* === ANIMATIONS === */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* === HERO === */
[quarkly-title="HeroBlock"] {
  position: relative;
}

[quarkly-title="HeroBlock"] > div {
  position: relative;
  z-index: 2;
}

/* === IMAGE HOVER — gentle zoom inside overflow containers === */
img {
  transition: transform 0.6s ease;
}

section[id="team"] [style*="overflow"],
[quarkly-title="Architecture Consulting Services"] [style*="55%"],
[quarkly-title="Sectors"] [style*="50%"] {
  overflow: hidden;
}

section[id="team"] [style*="overflow"]:hover img {
  transform: scale(1.03);
}

/* === LINK HOVER EFFECTS === */
a[href="#approach"], a[href="#services"], a[href="#team"], a[href="#contact"],
a[href="/#approach"], a[href="/#services"], a[href="/#team"], a[href="/#contact"] {
  position: relative;
  transition: color 0.3s ease;
}

a[href="#approach"]::after, a[href="#services"]::after, a[href="#team"]::after, a[href="#contact"]::after,
a[href="/#approach"]::after, a[href="/#services"]::after, a[href="/#team"]::after, a[href="/#contact"]::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 1px;
  background: currentColor;
  transition: width 0.3s ease;
}

a[href="#approach"]:hover::after, a[href="#services"]:hover::after, a[href="#team"]:hover::after, a[href="#contact"]:hover::after,
a[href="/#approach"]:hover::after, a[href="/#services"]:hover::after, a[href="/#team"]:hover::after, a[href="/#contact"]:hover::after {
  width: 100%;
}

/* === FOOTER LINKS === */
[quarkly-title="Footer"] a {
  transition: all 0.3s ease;
}

[quarkly-title="Footer"] a:hover {
  color: #111111 !important;
}

/* === SMOOTH SECTION TRANSITIONS === */
section {
  transition: background 0.6s ease;
}

/* === SELECTION COLOR === */
::selection {
  background: rgba(10, 25, 47, 0.15);
  color: #0A192F;
}

/* === MOBILE MENU HAMBURGER === */
[data-custom-hamburger] {
  width: 28px;
  height: 20px;
  position: relative;
  cursor: pointer;
  background: linear-gradient(to right, var(--darkL2, #333) 100%, transparent 0) no-repeat center center !important;
  background-size: 100% 2px !important;
  transition: background 0.3s ease;
}
[data-custom-hamburger]::before,
[data-custom-hamburger]::after {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--darkL2, #333);
  transition: transform 0.3s ease, top 0.3s ease, bottom 0.3s ease;
}
[data-custom-hamburger]::before {
  top: 0;
}
[data-custom-hamburger]::after {
  bottom: 0;
}
[data-custom-hamburger="open"] {
  background: transparent !important;
}
[data-custom-hamburger="open"]::before {
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}
[data-custom-hamburger="open"]::after {
  bottom: 50%;
  transform: translateY(50%) rotate(-45deg);
}

/* === SCROLL REVEAL === */
.reveal {
  opacity: 0;
  transition: opacity 0.8s ease;
}

.reveal.visible {
  opacity: 1;
}

/* === SCROLLBAR STYLING === */
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: #FFFFFF;
}

::-webkit-scrollbar-thumb {
  background: #CCCCCC;
  border-radius: 2px;
}

/* === QUARKLY BADGE HIDE === */
[quarkly-title="Badge"] {
  display: none !important;
}

/* === LEGAL PAGES (MAGAZINE STYLE) === */
.legal-document [data-custom-class="title"], .legal-document .title {
  font-family: "Poppins", sans-serif !important;
  font-size: 2.5rem !important;
  font-weight: 600 !important;
  color: #111111 !important;
  letter-spacing: -0.02em !important;
  margin-bottom: 0.5rem !important;
  display: block !important;
  line-height: 1.2 !important;
}

.legal-document [data-custom-class="subtitle"], .legal-document .subtitle {
  font-family: "Inter", sans-serif !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  color: #777777 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.1em !important;
  margin-bottom: 3rem !important;
  display: block !important;
}

.legal-document [data-custom-class="heading_1"], .legal-document .heading_1 {
  font-family: "Poppins", sans-serif !important;
  font-size: 1.5rem !important;
  font-weight: 600 !important;
  color: #111111 !important;
  margin-top: 3rem !important;
  margin-bottom: 1rem !important;
  display: block !important;
  line-height: 1.3 !important;
}

.legal-document [data-custom-class="heading_2"], .legal-document .heading_2 {
  font-family: "Poppins", sans-serif !important;
  font-size: 1.25rem !important;
  font-weight: 500 !important;
  color: #222222 !important;
  margin-top: 2rem !important;
  margin-bottom: 1rem !important;
  display: block !important;
  line-height: 1.4 !important;
}

.legal-document [data-custom-class="body_text"], .legal-document .body_text, .legal-document p {
  font-family: "Inter", sans-serif !important;
  font-size: 1rem !important;
  line-height: 1.8 !important;
  color: #555555 !important;
  font-weight: 300 !important;
}

.legal-document [data-custom-class="body_text"] + [data-custom-class="body_text"], 
.legal-document .body_text + .body_text,
.legal-document p + p {
  margin-top: 1rem !important;
}

.legal-document [data-custom-class="link"], .legal-document .link, .legal-document a {
  color: #111111 !important;
  text-decoration: none !important;
  border-bottom: 1px solid rgba(17, 17, 17, 0.3) !important;
  transition: all 0.3s ease !important;
  font-weight: 400 !important;
}

.legal-document [data-custom-class="link"]:hover, .legal-document .link:hover, .legal-document a:hover {
  border-bottom-color: #111111 !important;
  background-color: rgba(17, 17, 17, 0.03) !important;
}

.legal-document ul, .legal-document ol {
  padding-left: 1.5rem !important;
  margin-bottom: 1.5rem !important;
  color: #555555 !important;
  font-family: "Inter", sans-serif !important;
  font-size: 1rem !important;
  line-height: 1.8 !important;
  font-weight: 300 !important;
}

.legal-document li[data-custom-class="body_text"], .legal-document li.body_text, .legal-document li {
  margin-bottom: 0.5rem !important;
}

/* Remove excessive empty spaces */
.legal-document div:empty,
.legal-document p:empty {
  display: none;
}
`}
    </style>
  </RawHtml>
)

export const GlobalQuarklyPageStyles = ({ pageUrl }) => (
  <>
    <PageStyles styles={pageStyles[pageUrl]} />
    <GlobalCSS />
  </>
)
